var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnvironment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#062F53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9994 21.5574V18.4415L29.292 17.4789C28.917 16.5738 28.7278 16.1162 28.3528 15.2111L29.5861 12.6158C28.8526 11.8822 28.1182 11.1478 27.383 10.4127L24.7877 11.646C23.8826 11.271 23.425 11.0818 22.5199 10.7068L21.5574 8H18.4415L17.4789 10.7074C16.5738 11.0824 16.1162 11.2716 15.2111 11.6466L12.6158 10.4133C11.8822 11.1469 11.1478 11.8812 10.4127 12.6164L11.646 15.2117C11.271 16.1168 11.0818 16.5744 10.7068 17.4795L8 18.442V21.558L10.7074 22.5205C11.0824 23.4256 11.2716 23.8832 11.6466 24.7883L10.4133 27.3836C11.1469 28.1172 11.8812 28.8516 12.6164 29.5867L15.2117 28.3534C16.1168 28.7284 16.5744 28.9176 17.4795 29.2926L18.442 32H21.558L22.5205 29.2926C23.4256 28.9176 23.8832 28.7284 24.7883 28.3534L27.3836 29.5867C28.1172 28.8532 28.8516 28.1188 29.5867 27.3836L28.3534 24.7883C28.7284 23.8832 28.9176 23.4256 29.2926 22.5205L32 21.558L31.9994 21.5574ZM19.9994 24.7314C17.386 24.7314 15.2674 22.6128 15.2674 19.9994C15.2674 17.386 17.386 15.2674 19.9994 15.2674C22.6128 15.2674 24.7314 17.386 24.7314 19.9994C24.7314 22.6128 22.6128 24.7314 19.9994 24.7314Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvironment);
export default __webpack_public_path__ + "static/media/icon_environment.4011d9df.svg";
export { ForwardRef as ReactComponent };